import { RegisterTeamActivityStatus } from 'app/api/event/model'
import {
  ILocation,
  ITeam,
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { useGetActionRegisteredByTeam } from 'app/react-query/hook/event'
import { useMemo } from 'react'

export const useTeamRegisteredByStatusLayout = ({
  status,
  actionId,
}: {
  status: RegisterTeamActivityStatus
  actionId?: number
  listTeam?: ITeam[]
  locations?: ILocation[]
}) => {
  const { data: response, isLoading } = useGetActionRegisteredByTeam({
    activity_id: actionId,
    status,
  })

  const data = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  return {
    data,
    isLoading,
  }
}
